export const FULLSCREEN_LOADER_SIZE = 40;
